import { registerPageInit } from '../barba/page-init-registry';
import 'plyr/dist/plyr.css';
import '../../css/pages/about/about.scss';
import { ResponsiveCarouselWidget } from '../widgets/responsive-carousel-widget ';
import { initAboutPurposesPlyr } from '../utils/about-purposes-plyr';
import { initClusterAboutOperatingCarousels } from '../utils/init-cluster-about-operating-widgets';
import { ClusterResidentsSwiperWidget } from '../widgets/cluster-residents-swiper-widget';

class About {
  private aboutPartnersCarouselWidget: ResponsiveCarouselWidget;
  private responsiveEducationCarouselWidgetList: ResponsiveCarouselWidget[];
  private instance: ClusterResidentsSwiperWidget | null = null;

  constructor() {
    this.aboutPartnersCarouselWidget = new ResponsiveCarouselWidget({
      rootId: 'aboutPartnersCarousel',
      sourceId: 'aboutPartnersCarouselSource',
      breakpoints: { desktopXl: 4, desktop: 4, tablet: 3, middle: 2, mobile: 1 },
      indicators: true,
      fillIncompleteSlide: true,
    });

    const carouselList = document.querySelectorAll('[id^="aboutConstructionCarousel"]');
    this.responsiveEducationCarouselWidgetList = Array.from(carouselList).map((carousel) => {
      const rootId = carousel.id;

      const suffix = rootId.replace('aboutConstructionCarousel', '');
      const sourceId = 'aboutConstructionCardsSource' + suffix;

      return new ResponsiveCarouselWidget({
        rootId,
        sourceId,
        breakpoints: { desktopXl: 3, desktop: 3, tablet: 3, middle: 2, mobile: 1 },
        indicators: true,
      });
    });
  }

  public init(): void {
    initAboutPurposesPlyr();
    this.instance = initClusterAboutOperatingCarousels({
      galleryRootId: 'aboutPartnersCarousel',
      gallerySourceId: 'aboutPartnersCarouselSource',
      residentsRootId: '',
      residentsSourceId: '',
    });

    // this.aboutPartnersCarouselWidget.init();
    this.responsiveEducationCarouselWidgetList.forEach((widget) => {
      widget.init();
    });
  }
}

registerPageInit('about', () => {
  const page = new About();
  page.init();
});
